import { modalTypes } from "constants/types";
import { noop } from "lodash";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { hideModal, showModal } from "slices/app/actions/modals";
import { setListAsDefault } from "slices/watchwords/actions";

const useSetDefaultListHandler = ({ name, id, onComplete = noop } = {}) => {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(
      showModal(modalTypes.CONFIRMATION, {
        headerText: "Set Watchword List as Default",
        bodyText: `Are you sure you wish to set ${name} as Default?`,
        okButton: {
          text: "Yes, Set as Default",
          onOk: async () => {
            dispatch(hideModal(modalTypes.CONFIRMATION));
            const list = await dispatch(setListAsDefault(id));
            onComplete(list);
          },
        },
        cancelButton: {
          text: "Cancel",
          onCancel: () => {
            dispatch(hideModal(modalTypes.CONFIRMATION));
          },
        },
      })
    );
  }, [id, name]);
};

export default useSetDefaultListHandler;
